<template>
    <div class="quiz-view-header">
        <img class="quiz-view-header__logo" src="@/images/mackies-logo.svg"/>

        <a class="quiz-view-header__button button button--ghost button--lower" href="https://mackies.co.uk/" target="_blank">mackies.co.uk</a>
    </div>
</template>

<script>
export default {
    name: "QuizHeader"
}
</script>

<style scoped lang="stylus">

.quiz-view-header {
    display: flex;
    padding: 0.8em 1.5em;
    align-items: center;
    box-shadow: 0 0.15em 0.4em rgba(0, 0, 0, 0.2);
    justify-content: center;
    background: brand-taupe;
    color: brand-blue;
    gap: 1em;
    z-index: 501;

    &__button {
        display: none;
    }

    &__logo {
        width: 6em;
        display: block;
    }
}

@media (min-width: 600px) {
    .quiz-view-header {
        padding: 1em 5%;
        justify-content: space-between;
        height: 120px;
        box-sizing border-box;

        &__logo {
            width: 8em;
        }

        &__button {
            display: block;
        }
    }
}

    @media (min-width: 1000px) {
        .quiz-view-header {
            position: sticky;
            top: 0;
        }
    }

</style>